import { Moment } from "moment";

export class Activity{
    EndDate: Date;
    IsMaintenance: string;
    IsSchedule: string;
    Sstatus: number;
    StartDate: Date;
    StartDay: String;
    StartDayIndex: number;
    conflictCount: number;
    botId: number;
    systemId: number;
    AccessList: any [];
}

export class CalenderRes{
    AllMaintenanceArr: Activity [];
    AllScheduleArr: Activity [];
}

export class CalenderResponse{
    success: string;
    CalenderRes: CalenderRes;
}

export class CalenderDayEntries{
    startDate: Moment;
    endDate: Moment;
    conflictCount: number;
}

export class CalenderDay {
    split: boolean;
    StartDate: string;
    fromTop: number;
    length: number;
    end: number;
    start: boolean;
    stime: any;
    etime: any;
    scount: number;
    conflictCount: number;
}